
import { default as axios, AxiosResponse } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { State } from 'vuex-class';
import BarometerCollection from '../../components/overview/BarometerCollection.vue';
import Dashboard from '../../components/overview/Dashboard.vue';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { performance } from '../../shared/services/PerformanceService';
import { IAggregateState, IUserState } from '../../store/contract';
import store from '../../store/store';
const aggregateNamespace = 'aggregate';

@Component({
    components: {
        Dashboard,
        BarometerCollection
    }
})
export default class OrganizationDashboard extends Vue {
    @State(aggregateNamespace) aggregateState: IAggregateState;
    @State('user') userState: IUserState;

    private actionSnapshots: ISnapshotHypermediaRepresentation[] = [];
    protected areActionsLoading: boolean = false;
    private loadedActions = false;

    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track('All dashboard');
        await store.dispatch('aggregate/fetchRecentAggregate');
        await store.dispatch('aggregate/fetchAllAggregate');
        next();
    }

    created() {
        this.retrieveActionSnapshots();
    }

    protected retrieveActionSnapshots() {
        this.areActionsLoading = true;
        return axios
            .get(this.aggregateState.allAggregateItem._links.item_people_actions.href)
            .then((response: AxiosResponse<ISnapshotHypermediaRepresentation[]>) => {
                this.loadedActions = true;
                this.actionSnapshots = response.data;
                this.areActionsLoading = false;
            });
    }

    protected dashboardLoaded() {
        if (this.loadedActions) {
            this.$nextTick(() => {
                performance.end('All dashboard');
            });
        }
    }
}
